import React, { type AriaRole } from 'react';
import Icons, { type IconNames } from './Icons';

export type IconProps = {
  ariaHidden?: boolean;
  ariaLabel?: string;
  className?: string;
  name: IconNames;
  role?: AriaRole;
};

const Icon = ({ name, ...props }: IconProps) => {
  const ComponentToRender: React.ElementType | undefined = Icons?.[name];

  // Return nothing if invalid icon is requested
  if (!ComponentToRender) return null;

  return <ComponentToRender {...props} />;
};

export default Icon;
